export default __webpack_public_path__ + "static/media/blog_card.5ddc2795.svg";